import React, { PureComponent as Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';
import FilterForm from './FilterForm';

export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyword: props.keyword,
      active: props.active,
    };
    this._handleOnChangeInput = this._handleOnChangeInput.bind(this);
    this._handleApplyFilterButtonClick = this._handleApplyFilterButtonClick.bind(this);
  }

  _handleOnChangeInput(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  _handleApplyFilterButtonClick(e) {
    e.preventDefault();
    this.props.onApplyFilter({
      keyword: this.state.keyword,
      active: this.state.active,
      per_page: this.props.per_page,
      sort_by: this.props.sort_by,
    });
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.isReset && this.props.isReset !== nextProps.isReset) {
      this.setState({
        keyword: nextProps.keyword,
        active: nextProps.active,
      });
      return;
    }

    if (
      nextProps.keyword !== this.props.keyword ||
      nextProps.active !== this.props.active
    ) {
      this.setState({
        keyword: nextProps.keyword,
        active: nextProps.active,
      });
    }
  }

  render(){
    return(
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword = {this.state.keyword}
            onInputChange = {this._handleOnChangeInput}
            onSubmit = {this._handleApplyFilterButtonClick}
          />
          <FilterForm
            active={this.state.active}
            onCheckedChange={this._handleOnChangeInput}
            onSubmit={this._handleApplyFilterButtonClick}
          />
          <hr/>
          <SortForm
            per_page={this.props.per_page}
            sort_by={this.props.sort_by}
            onInputChange={this.props.onHandleChangeAndSubmit}
          />
        </CardBody>
      </Collapse>
    )
  }
}

Filters.propTypes= {
  keyword: propTypes.string,
  active: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  onApplyFilter: propTypes.func,
  onHandleChangeAndSubmit: propTypes.func,
  isReset: propTypes.bool
}

Filters.defaultProps= {
  keyword: '',
  active: '',
  per_page: 10,
  sort_by: ''
}
